import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NetzbetreiberType } from '../../domain/model/netzbetreibertype';
import { Sort, SortDirection } from '@angular/material/sort';
import { RoutingService } from '../../service/common/routing/routing.service';
import { PlanwertStatus } from '../../domain/model/planwert-status.enum';
import { PlanwertListEntry } from '../../domain/model/planwert-list-entry.model';
import { PlanwertType } from '../../domain/model/planwert-type.enum';

@Component({
    selector: 'redispatch-planwert-table',
    templateUrl: './planwert-table.component.html',
    styleUrls: [
        './planwert-table.component.scss',
    ],
    standalone: false,
})
export class PlanwertTableComponent {

    @Input()
    public planwerte: PlanwertListEntry[];

    @Input()
    public netzbetreiberType: NetzbetreiberType;

    @Input()
    public sortDirection: SortDirection;

    @Input()
    public sortActive: string;

    @Output()
    public sortChange = new EventEmitter<Sort>();

    public columnsToDisplay = [
        'erzeugungsanlage.dokumentenId',
        'erzeugungsanlage.resourceIds.technischeResourceId',
        'erzeugungsanlage.bezVnbIntern',
        'netzverknuepfungspunkt',
        'type',
        'originalValue',
        'plannedValue',
        'dataTransferDate',
        'status',
    ];

    protected routingService = inject(RoutingService);

    public _sortChange($event: Sort) {
        if ($event.direction === '') {
            $event.active = '';
        }
        this.sortChange.emit($event);
    }


    getErzeugungsanlagenFieldValueByPlanwerType(planwert: PlanwertListEntry) : string | number {
        switch (planwert.type) {
            case PlanwertType.BRUTTONENNLEISTUNG:
                return planwert.erzeugungsanlage.leistung?.bruttonennleistung;
            case PlanwertType.SR_ID:
                return planwert.erzeugungsanlage.resourceIds?.steuerbareResourceId;
            case PlanwertType.SG_ID:
                return planwert.erzeugungsanlage.resourceIds?.steuergruppeId;
            case PlanwertType.ANLAGENBETREIBER_NAME:
                return planwert.erzeugungsanlage.technischeResourceInformationen?.anlagebetreiberName;
            case PlanwertType.ANLAGENBETREIBER_STRASSE:
                return planwert.erzeugungsanlage.technischeResourceInformationen?.anlagebetreiberStrasse;
            case PlanwertType.ANLAGENBETREIBER_HAUSNUMMER:
                return planwert.erzeugungsanlage.technischeResourceInformationen?.anlagebetreiberHausnummer;
            case PlanwertType.ANLAGENBETREIBER_HAUSNUMMER_ZUSATZ:
                return planwert.erzeugungsanlage.technischeResourceInformationen?.anlagebetreiberHausnummerZusatz;
            case PlanwertType.ANLAGENBETREIBER_PLZ:
                return planwert.erzeugungsanlage.technischeResourceInformationen?.anlagebetreiberPLZ;
            case PlanwertType.ANLAGENBETREIBER_ORT:
                return planwert.erzeugungsanlage.technischeResourceInformationen?.anlagebetreiberOrt;
            case PlanwertType.MARKTLOKATION:
                return planwert.erzeugungsanlage.marktlokation?.code;
            case PlanwertType.BILANZKREIS:
                return planwert.erzeugungsanlage.marktlokation?.bilanzkreis;
            case PlanwertType.LIEFERANT_MARKTLOKATION:
                return planwert.erzeugungsanlage.marktlokation?.code;
            case PlanwertType.TRANCHE_MARKTLOKATION:
                return planwert.erzeugungsanlage.tranche?.marktlokation;
            case PlanwertType.TRANCHE_BILANZKREIS:
                return planwert.erzeugungsanlage.tranche?.bilanzkreis;
            case PlanwertType.TRANCHE_LIEFERANT:
                return planwert.erzeugungsanlage.tranche?.lieferant;
            case PlanwertType.TRANCHE_GROESSE:
                return planwert.erzeugungsanlage.tranche?.groesse;
        }
    }

    planwertStatusToClass(status: PlanwertStatus): string {
        switch (status) {
            case PlanwertStatus.OPEN:
                return 'open';
            case PlanwertStatus.PROCESSED:
                return 'success';
            case PlanwertStatus.INVALID:
            case PlanwertStatus.SYSTEM_FAILED:
                return 'failed';

        }
        return '';
    }
}
